// Configuración centralizada del proyecto
export const config = {
  // URLs de los servicios
  MONOLITO_API: process.env.VUE_APP_MONOLITO_API || 'http://localhost:5000',
  AUTH_API: process.env.VUE_APP_AUTH_API || 'http://localhost:8009',

  // Configuración de la aplicación
  APP_ID: process.env.VUE_APP_AUTH_APP_ID || 'medica',
  TENANT_ID: process.env.VUE_APP_AUTH_TENANT_ID || '550e8400-e29b-41d4-a716-446655440001',

  // Timeouts
  REQUEST_TIMEOUT: 10000,



  // Información de Contacto
  CONTACT: {
    PHONE: {
      DISPLAY: '0291 4510854',
      LINK: 'tel:02914510854'
    },
    WHATSAPP: {
      DISPLAY: '2914071621',
      LINK: 'https://wa.me/5492914071621'
    },
    ADDRESS: 'Terrada 374, Bahía Blanca',
    EMAIL: 'centromedicoterrada@gmail.com',
    SOCIAL: {
      INSTAGRAM: '#'
    }
  }
};

// Función para verificar si estamos en desarrollo
export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development';
};

// Función para obtener la URL del monolito
export const getMonolitoUrl = () => {
  return config.MONOLITO_API;
};

// Función para obtener la URL de auth
export const getAuthUrl = () => {
  return config.AUTH_API;
};

export default config; 